import 'virtual:uno.css'
import './assets/css/index.css'
import './assets/css/themes/violet.css'

import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useThemeStore } from './stores/theme'

const app = createApp(App)
const pinia = createPinia()

pinia.use(({ store }) => {
  store.router = markRaw(router)
})

app.use(pinia)
app.use(router)
app.use(i18n)

// Init theme before mount so there's no flash
useThemeStore().init()

app.mount('#app')
